"use client";

import { c as _c } from "react/compiler-runtime";
import { TextBody, Tooltip } from "@opensea/ui-kit";
import { Info } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
export const CreatorEarningsTooltip = t0 => {
  const $ = _c(7);
  const {
    creatorFeeEnforced,
    forAcceptOffersSummary: t1
  } = t0;
  const forAcceptOffersSummary = t1 === undefined ? false : t1;
  const t = useTranslations("wallet.CreatorEarningsTooltip");
  let t2;
  if ($[0] !== creatorFeeEnforced || $[1] !== forAcceptOffersSummary || $[2] !== t) {
    t2 = forAcceptOffersSummary && creatorFeeEnforced ? <TextBody>{t("enforcedForCollection")}</TextBody> : <><TextBody>{t("paidBySeller")}</TextBody>{creatorFeeEnforced && <TextBody> {t("enforced")}</TextBody>}</>;
    $[0] = creatorFeeEnforced;
    $[1] = forAcceptOffersSummary;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Info fill="text-secondary" size={16} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <Tooltip content={t2} side="bottom">{t3}</Tooltip>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};